import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/logo.png";
import {Avatar, Space, Dropdown, Badge, QRCode, Popover, Button, Modal} from "antd";
import {
  UserOutlined,
  ShoppingCartOutlined,
  HeartOutlined,
  SettingOutlined,
  LogoutOutlined,
  ClusterOutlined,
  AppstoreAddOutlined,
  AccountBookOutlined,
  AppstoreOutlined,
  LoginOutlined,
  TrademarkCircleOutlined,
  GroupOutlined,
  DropboxOutlined,
} from "@ant-design/icons";
import {Link, NavLink} from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectFavorites } from "../../app/store/reducers/main/mainReducer";
import { selectAccount, selectIsAdmin, selectIsAuthorized, selectIsOwner } from "../../app/store/reducers/auth/authReducer";
import { PATH_IMAGE } from "../../helper/path";

const Navbar = () => {
  const [show, setShow] = useState(false)
  const [items, setItems] = useState([])
  const account = useSelector(selectAccount)
  const owner = useSelector(selectIsOwner)
  const admin = useSelector(selectIsAdmin)
  const isAuthorized = useSelector(selectIsAuthorized)
  const favorites = useSelector(selectFavorites)

  const handleClose = () => {
    setShow(false)
  }

  const handleShow = () => {
    setShow(true)
  }

  useEffect(() => {
    if (admin) {
      console.log("admin");
      setItems(itemsWithToken)
    } else if (owner) {
      console.log("owner");
      setItems(itemsWithToken?.filter(item => !item?.isAdmin))
    } else {
      console.log("else");
      setItems(itemsWithToken?.filter(item => !item?.isAdmin && !item?.isOwner))
    }
  },[admin, owner])


  const itemsWithToken = [
    {
      key: "1",
      label: (
        <Link to="/profile" style={{fontSize: "17px"}}>
          Profile
        </Link>
      ),
      icon: <UserOutlined style={{fontSize: "18px", color: "black"}} />,
    },
    {
      key: "2",
      label: (
        <Link to="/admin/accounts" style={{fontSize: "17px", color: "red", fontWeight: "bold"}}>
          Admin
        </Link>
      ),
      isAdmin: true,
      icon: <ClusterOutlined style={{fontSize: "18px", color: "red", fontWeight: "bold"}} />,
    },
    {
      key: "3",
      label: (
        <Link to="product/my" style={{fontSize: "17px", color: "blue", fontWeight: "bold"}}>
          My product
        </Link>
      ),
      isOwner: true,
      icon: <DropboxOutlined style={{fontSize: "18px", color: "blue", fontWeight: "bold"}} />,
    },
    {
      key: "4",
      label: (
        <Link to="/settings" style={{fontSize: "17px"}}>
          Settings
        </Link>
      ),
      icon: <SettingOutlined style={{fontSize: "18px", color: "black"}} />,
    },
    {
      key: "5",
      color: "red",
      label: (
        <Link to="authentication/logout" style={{fontSize: "17px", color: "red"}}>
          Logout
        </Link>
      ),
      icon: <LogoutOutlined style={{fontSize: "18px", color: "red"}} />,
    },
  ];

  const itemsWithoutToken = [
    {
      key: "4",
      label: (
        <Link to="authentication/login" style={{fontSize: "17px"}}>
          Login
        </Link>
      ),
      icon: <LoginOutlined style={{fontSize: "18px"}} />,
    },
    {
      key: "5",
      label: (
        <Link to="authentication/registration" style={{fontSize: "17px"}}>
          Registration
        </Link>
      ),
      icon: <TrademarkCircleOutlined style={{fontSize: "18px"}} />,
    },
  ]

  const toolItems = [
    {
      key: "1",
      label: (
        <Link to="/product/category" style={{fontSize: "17px"}}>
          Category
        </Link>
      ),
      icon: <AppstoreOutlined style={{fontSize: "18px", color: "black"}} />,
    },
    {
      key: "2",
      label: (
        <Link to="/product/currency" style={{fontSize: "17px"}}>
          Currency
        </Link>
      ),
      icon: <AccountBookOutlined style={{fontSize: "18px", color: "black"}} />,
    },
  ]


  return (
    <>
      <Link to="/">
        <Space size={20} wrap className="">
          <Avatar size={44} src={<img src={Logo} alt="avatar" />} />
        </Space>
      </Link>

      <Space
        size={20}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >

      {/* <Button type="primary" onClick={handleShow}>
        QRCode
      </Button>
      <Modal title="Monaliza" open={show} onOk={handleClose} onCancel={handleClose} className="d-flex justify-content-center align-items-center">
      <QRCode value="http://monaliza.uz/" bordered={false} />
      </Modal> */}


        {owner &&
          <Dropdown
          menu={{
            items: toolItems,
          }}
          dropdownRender={(menu) => {
            return <div>{React.cloneElement(menu)}</div>;
          }}
        >
          <Space style={{marginTop: "15px"}}>
            <GroupOutlined style={{fontSize: "28px"}} />
          </Space>
        </Dropdown>
        }
        
        <Link to="/favorites">
          <Badge count={favorites?.length || 0}>
            <HeartOutlined
              key="favorite"
              style={{fontSize: "30px", display: "inline"}}
            />
          </Badge>
        </Link>
        <Link to="/cart">
          <Badge count={0}>
            <ShoppingCartOutlined
              key="shopping"
              style={{fontSize: "30px", color: "gray", display: "inline"}}
            />
          </Badge>
        </Link>
        <Dropdown
          menu={{
            items: isAuthorized ? items : itemsWithoutToken,
          }}
          dropdownRender={(menu) => {
            return <div>{React.cloneElement(menu)}</div>;
          }}
        >
          <Space>
            {account?.image?.path ?
              <Avatar src={<img src={PATH_IMAGE+account?.image?.path} alt="avatar" />}/>
              :
              <Avatar size={40} icon={<UserOutlined />} />
            }
          </Space>
        </Dropdown>
      </Space>
    </>
  );
};

export default Navbar;
